// Lib
import classNames from 'classnames';
import React, { ReactElement } from 'react';

// Components
import Icon from '../../../../../../../components/icons/Icon';
import Button, { ButtonProps } from '../../../../../../../components/buttons/Button';

// Styles
import './AiButton.scss';

interface AiButtonProps extends ButtonProps {
    iconName?: string;
    children: ReactElement | string;
}

const AiButton = (props: AiButtonProps): ReactElement => {
    const { children, className, iconName } = props;

    return (
        <Button {...props} className={classNames('AiButton', className)}>
            {iconName && <Icon name={iconName} />}
            {children}
        </Button>
    );
};

export default AiButton;
